import notEmptySelfOrTarget from '@model/_shared/validator/notEmptySelfOrTarget'

export const validators = {
  parent: notEmptySelfOrTarget,
  supportedBy: notEmptySelfOrTarget,
}

export {
  validators as default,
  notEmptySelfOrTarget,
}
